<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 26 26"
    height="40"
    width="40"
  >
    <g transform="translate(1, 1)">
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/misc/course"
      >
        <path
          :fill="color"
          id="Shape"
          d="M21.859338,5.14429826 C21.7700077,5.05178167 21.6486784,5 21.5226826,5 L20,5 L20,3.49296153 C20,3.22024472 19.7866738,3 19.5240159,3 L19.0220993,3 C15.4455518,3 13.3502883,3.53714856 11.999,4.83583292 C10.6477117,3.53714856 8.55244825,3 4.9759008,3 L4.47598413,3 C4.21332622,3 4,3.22024472 4,3.49296153 L4,5 L2.47665078,5 C2.34732176,4.99930958 2.2279924,5.05178167 2.13866204,5.14429826 C2.04933169,5.23681485 1.99933336,5.36316213 1.99933336,5.49365195 L2.00637405,18.5070385 C2.00637405,18.7797553 2.21970027,19 2.48302483,19 L3.07833831,19 C9.48612472,19 10.8490384,20.6478846 10.9843672,20.8204902 C11.0750308,20.933029 11.209693,21 11.3530216,21 L12.6463118,21 C12.790307,21 12.9249692,20.933029 13.0156328,20.8204902 C13.150295,20.6478846 14.5202493,19 20.9280357,19 L21.5233492,19 C21.7866738,19 22,18.7797553 22,18.5070385 L22,5.49365195 C21.9993334,5.36316213 21.9486684,5.23681485 21.859338,5.14429826 Z M3,18 L3,6 L4,6 L4,18 C3.82045043,17.9961122 3.4871171,17.9961122 3,18 Z M5,18.1800921 L5,4 C8.48055065,4 10.3770541,4.49545472 11.5230159,5.73545319 L11.5,20 C10.8693544,19.400023 9.35185494,18.3892901 5,18.1800921 Z M12.4763175,19.9802463 L12.4763175,5.73545319 C13.6216126,4.49545472 15.520116,4 19,4 L19,18 C14.6468118,18.209198 13.1069631,19.3802693 12.4763175,19.9802463 Z M21,18 C20.5128829,17.9958575 20.1795496,17.9958575 20,18 L20,6 L21,6 L21,18 Z"
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
    name: 'CourseIcon',
    props: {
      color: {
        type: String,
        default() {
          return "#256AB3";
        },
      },
    },
}
</script>